module.exports = __webpack_public_path__ + "assets/media/day1.d4c536c3.mp3";